<template>
    
    <div class="main">
        <c-panel>
            <form-autorizacao :paramId="$route.params.id" v-on:onSubmitAutorizacao="onSubmitAutorizacao"></form-autorizacao>
        </c-panel>
    </div>
    
</template>
<script>

import formAutorizacao from "./form"

export default {
    methods:{

        onSubmitAutorizacao(){

            this.$router.push('/admin/autorizacao');  
        }
    },
    components:{ formAutorizacao }
}
</script>
